class PanelPermission {
  constructor({
    pk,
    route_id,
    action_name,
    action_type,
    action_url,
    icon,
    permission,
    extra_data,
    is_active,
    is_deleted,
    created_at,
    modified_at,
    plugin // plugin object added
  }) {
    this.pk = pk;
    this.route = route_id;
    this.name = action_name;
    this.type = action_type;
    this.url = action_url === 'null' ? null : action_url;
    this.icon = icon;
    this.permission = permission;
    this.extra_data = extra_data;
    this.isActive = is_active;
    this.isDeleted = is_deleted;
    this.createdAt = created_at;
    this.modifiedAt = modified_at;
    this.plugin = plugin; // plugin object added
  }
}

export default PanelPermission;